<template>
  <base-modal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
    size="xl"
  >
    <template #header>
      <span v-if="addTaskWithoutFinish">{{$t('buttons.addTaskWithoutFinishCurrent')}}</span>
      <span v-else>{{$t('buttons.finishLastTaskAndClose')}}</span>
    </template>
    <template #body>
      <b-alert v-if="addTaskWithoutFinish" show variant="info">{{$t('views.excmtask.form.addTaskWithoutFinishInfo')}}</b-alert>
      <create
        :case-iri="idCase"
        :add-task-without-finish="addTaskWithoutFinish"
      ></create>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '../Create'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'CreateTaskModal',
  components: {
    BaseModal,
    Create
  },

  props: ['idCase', 'addTaskWithoutFinish'],

  computed: {
    ...mapGetters({
      isVisible: 'excmtask/createModal/isVisible',
      created: 'excmtask/create/created',
      dispatchData: 'excmtask/createModal/dispatchData',
      documentsToUpload: 'excmtask/createModal/documentsToUpload'
    })
  },

  watch: {
    async created (val) {
      if (val) {
        await this.uploadTaskDocuments(getId(val['@id']))
        this.dispatch()
      }
    }
  },
  methods: {
    dispatch () {
      let params = this.created.idTaskType.taskParams
      if (this.dispatchData.addToPool) {
        this.hideModal()
        return
      }
      if (!params.autoDispatch) {
        this.hideModal()
        return
      }
      if (params.canBeDailyPlanItem && this.dispatchData.date) {
        this.dispatchDailyPlanTask()
      } else if (this.dispatchData.userData) {
        this.dispatchPoolTask()
      }
      this.hideModal()
    },
    async dispatchDailyPlanTask () {
      let params = {
        idUserData: parseInt(getId(this.dispatchData.userData)),
        date: this.$moment(this.dispatchData.date).format('YYYY-MM-DD'),
        taskId: getId(this.created['@id'])
      }
      await new ApiService(`e_x_c_m_tasks/${params.taskId}/dispatch`).putSilent(params)
    },
    async dispatchPoolTask () {
      let id = getId(this.created.lastPoolTask['@id'])
      let data = {
        operationTransferUserData: this.dispatchData.userData,
        operation: 3
      }
      await new ApiService(`e_x_c_m_pool_tasks/${id}`).putSilent(data)
    },
    async setDocumentType (documentId, documentTypeId, attachToEmail) {
      await new ApiService(`e_x_c_m_document_files/${getId(documentId)}`).putSilent({ idDocumentType: documentTypeId, attachToEmail: attachToEmail })
    },
    async uploadSingleFile (document, newTaskId) {
      let link = 'api/e_x_c_m_tasks/' + newTaskId + '/upload_document'
      let formData = new FormData()
      formData.append('document', document.document)
      formData.append('title', document.title)
      await this.$http.post(link,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: function (progressEvent) {
            document.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
          }
        }
      ).then(async response => {
        if (response.status === 201) {
          await this.setDocumentType(response.data['@id'], document.documentType, document.attachToEmail)
        } else if (response.status === 207) {
          let text = ''
          for (let i in response.data) {
            text += response.data[i] + '\n'
          }
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
      }).catch(error => {
        if (error.response.status === 400) {
          let text = error.response.data['hydra:description']
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
        console.log(error)
      })
    },
    async uploadTaskDocuments (newTaskId) {
      for (let i in this.documentsToUpload) {
        await this.uploadSingleFile(this.documentsToUpload[i], newTaskId)
      }
      this.setDocumentsToUpload([])
    },
    hideModal () {
      this.$emit('modalHidden', true)
      this.setDocumentsToUpload([])
      this.$store.state.modals.updateTaskParams.close = 1
      this.toggleModal()
    },
    ...mapActions({
      // reset: 'excmtask/create/reset'
    }),
    ...mapMutations({
      toggleModal: 'excmtask/createModal/toggleModal',
      setDocumentsToUpload: 'excmtask/createModal/setDocumentsToUpload'
    })
  }
}
</script>

<style scoped>

</style>
